import { PhoneNumberWithPrefixSchema } from "@modules/box/boxTypes"
import { ExperienceLevel, Goals, HeardAboutUs, LeadType } from "@modules/boxLead/entities/boxLeadTypes"
import { BoxStaffLightDtoSchema } from "@modules/boxStaff/gateway/boxStaffDto"
import { UserDtoSchema } from "@modules/profile/userProfile/userDto"
import { z } from "zod"

// Many fields are set to null because, if the lead type is different from MANUAL_ADDITION, we don't have the information.
export const BoxLeadDtoSchema = z
  .object({
    id: z.string(),
    boxMemberLight: z
      .object({
        boxMemberId: z.string(),
        user: UserDtoSchema,
      })
      .nullable(),
    boxId: z.string(),
    user: UserDtoSchema.nullable(), // If null the lead is not a user of the app
    experienceLevel: z.enum(ExperienceLevel).nullable(), // If null the lead don't have experience level
    goals: z.array(z.enum(Goals)).nullable(), // If null the lead don't have goals
    hearAboutUs: z.enum(HeardAboutUs).nullable(), // If null the lead don't have a source
    hearAboutUsSpecify: z.string().max(255).nullable(), // Not null if hearAboutUs is OTHER
    bestTimeToContact: z.string().max(255).nullable(), // Not null if the lead has a best time to contact
    madeByStaff: BoxStaffLightDtoSchema.nullable(), // If null the lead type is other than MANUAL_ADDITION
    firstname: z.string().max(64).nullable(),
    lastname: z.string().max(64).nullable(),
    email: z.email().max(320).nullable(),
    phoneNumber: PhoneNumberWithPrefixSchema.nullable(),
    note: z.string().max(255).nullable(),
    firstContact: z.iso.datetime(),
    leadType: z.enum(LeadType).nullable(),
    isHot: z.boolean().nullable(),
  })
  .refine((data) => {
    if (data.user === null && (data.firstname === null || data.lastname === null)) {
      return false
    }
    return true
  })
  .meta({ id: "BoxLeadDtoSchema" })

export type BoxLeadDto = z.infer<typeof BoxLeadDtoSchema>

export enum LeadColumnToSort {
  NAME = "NAME",
  LEAD_TYPE = "LEAD_TYPE",
}
